import { DetailBar, Flex, Icon, Number, Tag, Text } from "components/common"
import { t } from "i18next"
import { Link, useNavigate } from "react-router-dom"
import { localisedValue } from "utils"
import theme from "utils/themeVars"
import { PROJECTS_LISTING_PATH } from "constants/app-paths"
import { DATE_FORMAT, TIME_FORMAT } from "constants"
import { useMemo } from "react"
import { TitleDescription } from "components/custom"
import { Row } from "antd"
import { dateTimeFunction } from "utils/date"

export default function FractionalSaleDetailCard({ sale }) {
  const navigate = useNavigate()
  const { contract } = sale || {}
  const project = contract?.project
  const projectName = localisedValue({ object: project, key: "name" })
  const typeName = localisedValue({ object: contract?.Type, key: "name" })
  const headline =
    projectName && typeName
      ? `${projectName} - ${typeName} (${t("Block")})`
      : [projectName, typeName].filter(Boolean).join(" - ") || "—"

  const blocks = contract?.numberOfBlocks ?? contract?.blockCount ?? "—"
  const dealPrice = contract?.dealPrice
  const contractId = contract?.contractId
  const expiryDate = contract?.expiryDate

  const contractsHref = contractId ? `/contracts/?contractId=${contractId}&status=all&contractScope=fractional` : null

  const renderDetailHeader = () => {
    return (
      <Flex align="center" gap={"8px"} wrap="wrap" className="mbe-8">
        <Text
          className="text-link pointer"
          color={theme["accent-color"]}
          onClick={() => navigate(PROJECTS_LISTING_PATH + `?projectId=${project?.projectId}`)}
        >
          {headline}
        </Text>
        <Tag type="light">
          <Icon icon="MyZameenLogo" size={16} style={{ fill: "#222", width: 70, height: 14 }} />
        </Tag>
      </Flex>
    )
  }

  const saleDetail = useMemo(() => {
    const blocksDetail = {
      label: <Text className="semiBold">{t("Property Blocks")}</Text>,
      value: <Text className="semiBold">{blocks}</Text>,
    }
    const purchaseAmountDetail = {
      label: <Text className="semiBold">{t("Purchase Amount")}</Text>,
      value: (
        <Text className="semiBold">
          {dealPrice != null ? <Number value={dealPrice} isCurrency isStringOnly className="bold" /> : "—"}
        </Text>
      ),
    }
    const contractIdDetail = {
      component: (
        <TitleDescription
          style={{
            flexBasis: "100%",
            width: "100%",
            marginTop: 14,
            paddingTop: 12,
          }}
          title={<Text type="secondary">{t("Contract ID")}</Text>}
          description={
            <Row align="bottom" style={{ gap: "2px 4px" }}>
              <Text>{contractId ? <Link to={contractsHref}>{contractId}</Link> : (contractId ?? "—")}</Text>{" "}
              {expiryDate && (
                <Text className="small" type="danger">
                  ({t("Expiry")} {dateTimeFunction({ date: expiryDate, format: DATE_FORMAT })}{" "}
                  {dateTimeFunction({ date: expiryDate, format: TIME_FORMAT })})
                </Text>
              )}
            </Row>
          }
        />
      ),
    }
    const details = [blocksDetail, purchaseAmountDetail, contractIdDetail]
    return details.filter(detail => detail?.component || detail?.value != null)
  }, [blocks, dealPrice, contractId, contractsHref, expiryDate])

  return (
    <DetailBar
      detailData={saleDetail}
      detailHeader={renderDetailHeader()}
      bgColor={theme["gray100"]}
      borderColor={theme["gray800"]}
    />
  )
}
